import React, {useEffect, useState} from 'react';
import {Alert, Button, Checkbox, Input, InputNumber, Popconfirm, Radio, Spin, Splitter} from "antd";
import ApiHandleSuccessMessage, {ApiHandleErrorMessage} from "@/lib/helper/apiHandleResultMessage";
import {useApiDeleteAdminPollQuestionId, useApiUpdateAdminPollQuestionId} from "@/api/question";
import {useNavigate, useParams} from "react-router-dom";
import {useFormik} from "formik";
import {ErrorMessageWidget} from "@/components/form/errorMessageWidget";
import TextArea from "antd/lib/input/TextArea";
import {optionType} from "@/pages/admin/survey/edit/_section/variable";
import {DeleteOutlined} from "@ant-design/icons";
import EditOptionSection from "@/pages/admin/survey/edit/_section/editOptionSection";
import useWindowDimensions from "@/hook/useWindowDimensions";
import {useApiReadAdminPollSurvey} from "@/api/survey";
import PermList from "@/lib/helper/PermList";
import {Can} from "@/components/can/Can";

function EditQuestionSection({question, index, refetch}) {

    const {width} = useWindowDimensions();
    const param = useParams()
    const survey_id = param.id;
    const [optionTypeSelection, setOptionTypeSelection] = useState('single_choice')
    const [randoOption, setRandomOption] = useState(false)
    const [isRequired, setIsRequired] = useState(false)
    const [deleted, setDeleted] = useState(false)
    const [rate, setRate] = useState(1)
    const [forTeacher, setForTeacher] = useState(false)
    const id = question.id;

    const navigate = useNavigate();

    const {mutate: deleteQuestion, isPending: isPendingDelete} = useApiDeleteAdminPollQuestionId()
    const {mutate: editQuestion, isPending: isPendingEdit} = useApiUpdateAdminPollQuestionId()
    const {data: surveyDetail, isPending: isPendingGetSurvey} = useApiReadAdminPollSurvey(survey_id)
    const formik = useFormik({
        initialValues: {}, validate: (values) => {
            return {};
        }, onSubmit: (values) => {
            values.random_options = false
            values.type = optionTypeSelection
            values.required = isRequired
            values.survey_id = survey_id
            values.rate = rate
            values.for_teacher = forTeacher

            editQuestion({id: id, data: values},
                {
                    onSuccess: (res) => {
                        ApiHandleSuccessMessage(res)
                        refetch()
                    },
                    onError: (res) => {
                        ApiHandleErrorMessage(res)
                    },
                })
        }
    })

    useEffect(() => {
        formik.setFieldValue('title', question?.title)
        formik.setFieldValue('description', question?.description)
        formik.setFieldValue('type', question?.type)
        setOptionTypeSelection(question?.type)
        setRandomOption(!!question.random_options)
        setIsRequired(!!question.required)
        setRate(question?.rate || rate)
        setForTeacher(!!question?.for_teacher)
    }, [question, survey_id]);

    const confirmRemove = (e) => {
        deleteQuestion({id: question?.id},
            {
                onSuccess: (res) => {
                    ApiHandleSuccessMessage(res)
                    setDeleted(true)
                    refetch()
                },
                onError: (res) => {
                    ApiHandleErrorMessage(res)
                },
            })
    };


    if (deleted) {
        return <div className={'flex justify-center'}><Spin/></div>
    }

    return (
        <>
            <Splitter layout={width < 600 ? 'vertical' : 'horizontal'}>
                <Splitter.Panel defaultSize="60%" min="30%" max="80%">
                    <div className={'m-2'}>
                        <div className={`flex flex-col gap-1`}>
                            <span className={`font-bold`}>عنوان </span>
                            <Input placeholder={"عنوان را وارد کنید"}
                                   disabled={isPendingEdit}
                                   value={formik.values.title}
                                   status={formik.errors.title && "error"}
                                   onChange={(e) => formik.setFieldValue("title", e.target.value)}
                            />
                            {formik.errors.title && <ErrorMessageWidget message={formik.errors.title}/>}
                        </div>
                        <div className={`flex flex-col gap-1`}>
                            <span className={`font-bold`}>توضیحات</span>
                            <Input.TextArea placeholder={"توضیحات"}
                                      value={formik.values.description}
                                      disabled={isPendingEdit}
                                      status={formik.errors.description && "error"}
                                      onChange={(e) => formik.setFieldValue("description", e.target.value)}
                            />
                            {formik.errors.description && <ErrorMessageWidget message={formik.errors.description}/>}
                        </div>
                    </div>
                </Splitter.Panel>
                <Splitter.Panel>
                    <div className="m-2">
                        <div className={'mt-4 flex-col gap-1'}>
                            <span className={`font-medium ml-1`}></span>
                            <Checkbox
                                disabled={isPendingEdit}
                                checked={!!isRequired}
                                onChange={(e) => setIsRequired(e.target.checked)}>الزامی</Checkbox>
                        </div>

                        {surveyDetail?.data?.data?.event === 'certificate' && <div className={'mt-4 flex-col gap-1'}>
                            <span className={`font-medium ml-1`}></span>
                            <Checkbox
                                disabled={isPendingEdit}
                                checked={!!forTeacher}
                                onChange={(e) => setForTeacher(e.target.checked)}>سوال از استاد</Checkbox>
                            {!!forTeacher && <Alert
                                message={'این سوال به ازای تمامی اساتیدی که در دریافت گواهی نامه شخص دخیل بوده اند پرسیده خواهد شد'}></Alert>}
                        </div>}


                        <div className={'mt-4 flex-col gap-1'}>
                            <span className={`font-medium ml-1`}>نوع گزینه‌ها</span>
                            <Radio.Group
                                disabled={isPendingEdit}
                                options={optionType}
                                onChange={(e) => setOptionTypeSelection(e.target.value)}
                                value={optionTypeSelection}
                                optionType="button"
                            />
                        </div>
                        {optionTypeSelection !== 'text' && <div className={'mt-4 flex-col gap-1'}>
                            <span className={`font-medium ml-1`}>ضریب سوال</span>
                            <InputNumber
                                min={0}
                                max={100}
                                value={rate}
                                disabled={isPendingEdit}
                                className="w-full"
                            />
                        </div>}

                    </div>
                </Splitter.Panel>
            </Splitter>
            <div className={`mt-4 flex justify-end gap-2`}>
                <Can permission={PermList.SURVEY_EDIT}>
                    <Popconfirm
                        title="حذف سوال"
                        description="آیا از حذف این سوال اطمینان دارید"
                        onConfirm={confirmRemove}
                        okText="بله"
                        cancelText="خیر"
                    >
                    <span>
                        <Button danger loading={isPendingDelete}>
                            <DeleteOutlined className={'text-red-600'}/>
                            حذف سوال
                        </Button>
                    </span>
                    </Popconfirm>

                    <Button onClick={formik.submitForm} type={'primary'} loading={isPendingEdit}
                            disabled={isPendingEdit || isPendingDelete}>
                        {'ویرایش'}
                    </Button>
                </Can>
            </div>

            {optionTypeSelection !== 'text' && (
                <div className={'m-1'}><EditOptionSection questionId={question?.id} options={question?.options}/>
                </div>)}
        </>
    );
}

export default EditQuestionSection;